import classNames from 'classnames';
import style from 'acscp/components/common/sideScreen.module.scss';
import { AppState, LanguageState, Menu } from 'acscp/store';
import { ChangeLocaleManually, SetOpenMenu } from 'acscp/actions';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { PresentationComponentBase } from 'acscp/components/presentationComponentBase';
import React from 'react';
import { SideScreen } from '../common/sideScreen';
import { FormattedMessage } from 'react-intl';
import { CrossIcon } from '../common/icons/crossIcon';
import { LanguageSign } from './languageSign';
import { getDisplayedLocaleCodes, getFirstValidLocaleFromList, LocaleCode } from 'acscp/translations';
import { ChangeLocaleAutomatically } from 'acscp/actions';

interface LanguageMenuStateProps {
    isOpen: boolean;
    languageState: LanguageState;
}

interface LanguageMenuDispatchProps {
    changeLocaleManually: (locale: LocaleCode) => void;
    changeLocaleAutomatically: (locale: LocaleCode) => void;
    closeMenu: () => void;
}

export class LanguageMenuPresentational
    extends PresentationComponentBase<{},
    LanguageMenuStateProps,
    LanguageMenuDispatchProps,
    {}> {

    setLocale(locale: LocaleCode): void {
        this.props.changeLocaleManually(locale);
        this.props.closeMenu();
    }

    componentDidMount(): void {
        if (this.props.languageState <= LanguageState.SetByBrowser) {
            const browserLanguages = navigator.languages
                || [navigator.language,
                    (navigator as any).userLanguage,
                    (navigator as any).browserLanguage];
            const browserLanguage = getFirstValidLocaleFromList(browserLanguages);
            this.props.changeLocaleAutomatically(browserLanguage);
        }
    }

    render(): JSX.Element | null {
        const {isOpen, closeMenu} = this.props;
        if (isOpen) {
            return (
                <SideScreen>
                    <div className={style.BlueHeader}>
                        <FormattedMessage
                            id={'components.customerContactDetails.languageHeader'}
                            defaultMessage={'CHOOSE LANGUAGE'}
                        />
                        <a href="javascript:;" id="Exit" onClick={closeMenu} aria-label="Close">
                            <CrossIcon />
                        </a>
                    </div>
                    {getDisplayedLocaleCodes().map(locale => (
                        <div className={classNames(style.MediumItem, style.WithBorder)} key={locale}>
                            <button className={style.Info} onClick={() => this.setLocale(locale)}>
                                <LanguageSign localeCode={locale}/>
                            </button>
                        </div>
                    ))}
                </SideScreen>
            );
        } else {
            return (
                null
            );
        }
    }
}

function mapStateToProps(state: AppState, ownProps: {}): LanguageMenuStateProps {
    return {
        isOpen: state.menu.currentlyOpenMenu === Menu.Language,
        languageState: state.intl.languageState
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: {}): LanguageMenuDispatchProps {
    return {
        changeLocaleManually: (locale: LocaleCode) => dispatch(new ChangeLocaleManually(locale)),
        changeLocaleAutomatically: (locale: LocaleCode) => dispatch(new ChangeLocaleAutomatically(locale)),
        closeMenu: () => dispatch(new SetOpenMenu(undefined))
    };
}

export const LanguageMenu = connect(mapStateToProps, mapDispatchToProps)(LanguageMenuPresentational);
